export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "en": {
        "available": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Available"])}
      },
      "de": {
        "available": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Verfügbar"])}
      }
    }
  })
}